export default __webpack_public_path__ + "static/media/copy-link-icon.1a4542ab.png";